import listSaga from './listSaga'
import loginSaga from './loginSaga'

const chatDetailsSagas = [listSaga(), loginSaga()]

export default chatDetailsSagas
